import { Injectable, signal } from '@angular/core';

/**
 * Backdrop state for error toasts. ErrorOverlayToastrService drives it from
 * ToastrService.error(); LayoutComponent renders the dimming backdrop from it.
 */
@Injectable({ providedIn: 'root' })
export class ErrorOverlayService {
  private readonly _isVisible = signal(false);
  readonly isVisible = this._isVisible.asReadonly();

  private _dismissToast: (() => void) | null = null;

  show(dismissToast: () => void): void {
    this._dismissToast = dismissToast;
    this._isVisible.set(true);
  }

  /** Backdrop click: dismisses the overlay and the toast that opened it. */
  dismiss(): void {
    this._dismissToast?.();
    this.close();
  }

  /** Toast already closed by other means (tap, timeout) — just drop the backdrop. */
  close(): void {
    this._dismissToast = null;
    this._isVisible.set(false);
  }
}
